import { render, staticRenderFns } from "./UnitTypes.vue?vue&type=template&id=15198824"
import script from "./UnitTypes.vue?vue&type=script&lang=js"
export * from "./UnitTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports